import { servicePost } from "./client.ts";
import type { ReturnObject } from "../types/returnObject.ts";

/* ── Types ─────────────────────────────────────────────── */

export interface CustomerDetails {
  CustomerID: number;
  Name: string;
  Email: string;
  Phone: string;
  CardExpireDate: string;
  BlockDate: string;
  BlockReason: string;
  BlockOverrideDate: string;
  Blocked: boolean;
  CardIBAN: string;
}

export const enum CustomerOp {
  SetBlocked = 0x10,
  SetBlockOverride = 0x100,
  SetEmail = 0x1000,
  AddCredit = 0x10000,
}

/* ── API ───────────────────────────────────────────────── */

export function getCustomerInfo(customerID: number): Promise<ReturnObject<CustomerDetails>> {
  return servicePost<CustomerDetails>("GetCustomerInfo", { customerID });
}

export function setCustomerData(customerID: number, operation: number, value: string): Promise<ReturnObject<boolean>> {
  return servicePost<boolean>("SetCustomerData", { customerID, operation, value });
}

export function setCustomerPhone(customerID: number, phone: string): Promise<ReturnObject<boolean>> {
  return servicePost<boolean>("WebSetCustomerPhone", { customerID, phone });
}

/* ── GDPR Removal ──────────────────────────────────────── */

export interface CustomerGdprRemovalArgs {
  CustomerID: number;
  OverrideBlock: boolean;
  OverrideRisk: boolean;
  OverrideSuspicious: boolean;
  ValidateOnly?: boolean;
}

export function customerGdprRemoval(args: CustomerGdprRemovalArgs): Promise<ReturnObject<string>> {
  return servicePost<string>("CustomerGdprRemoval", { args });
}
